import styled, { Font, Color, Breakpoint, Utils } from '@nfinite/react-hubstairs/styled'

export const StyledLink = styled('span').withConfig({ shouldForwardProp: prop => !['color'].includes(prop) })`
  color: ${({ color }) => Color.get(color)};
  ${Font.generate({ weight: 'regular' })}
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;

  &:hover {
    color: ${({ color }) => Color.get(color, 'light')};
  }
  ${Breakpoint.greaterThanMobile()} {
    ${Utils.generateScaleRollhover()}
  }
`
